class SelectToDropdownDirective {
    constructor($compile, $timeout) {
        this.restrict = 'A';
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.scope = {
            onSelectNotAvailableVariant: '&',
            allowSelectionNotAvailableVariant: '@',
            dropdownAlwaysShown: '@'
        };
        this.initComplete = false;
    }

    link(scope, element) {

        scope.allowSelectionNotAvailableVariant = scope.allowSelectionNotAvailableVariant === 'true';
        scope.dropdownAlwaysShown = scope.dropdownAlwaysShown === 'true';
        scope.uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

        const observer = new MutationObserver(function(mutations) {
            scope.createRefreshDropdown(scope, element);
            scope.$apply();
        });

        observer.observe(element[0], {
            childList: true,
            subtree: true,
            attributes: true
        });

        element[0].onchange = () => {
            scope.createRefreshDropdown(scope, element);
            scope.$apply();
        }

        scope.createRefreshDropdown = (scope, element) => {
            const existingContainer = document.getElementById(`select-to-dropdown-container-${scope.uniqueId}`);
            if (existingContainer) {
                existingContainer.remove();
            }

            const options = [];
            let selected = null;

            for (const optionRaw of Array.prototype.slice.call(element.children())) {
                const $optionRaw = angular.element(optionRaw);
                const description = $optionRaw[0].dataset.description;
                const info = $optionRaw[0].dataset.info;
                const canBuy = !!parseInt($optionRaw[0].dataset.canBuy);

                const key = $optionRaw.prop('value');
                const value = $optionRaw.text();
                const optionObj = {key, value, raw: optionRaw, info, description, canBuy};

                options.push(optionObj);

                if ($optionRaw.prop('selected')) {
                    selected = optionObj;
                }
            }

            scope.options = options;
            scope.selected = selected;

            scope.select = (option) => {
                selected = option;
                scope.selected = option;
                scope.options_length = 4444;

                this.$timeout(() => {
                    element.val(option.key).triggerHandler("change");
                });
            };

            scope.close = () => {
                scope.createRefreshDropdown(scope, element);
            }

            scope.selectNotAvailableVariant = (variant) => {
                if (scope.onSelectNotAvailableVariant) {
                    scope.onSelectNotAvailableVariant({variantId: variant.key});
                }
                if (scope.allowSelectionNotAvailableVariant) {
                    scope.select(variant);
                }
            }

            const container = angular.element(`
                <div class="select-to-dropdown-container" id="select-to-dropdown-container-${scope.uniqueId}">
                    <button type="button" dropdown target-id="select-to-dropdown-${scope.uniqueId}" triggers="click" ng-if="${options.length} > 1 || ${scope.dropdownAlwaysShown}">
                        <span ng-if="selected">{{ selected.value }}</span>
                        <span ng-if="!selected">Wybierz opcję</span>
                        <svg width="15" height="15">
                            <use xlink:href="/templates/rowerystylowenew/dist/spritemap.svg?v=202406200#sprite-arrow-down"></use>
                        </svg>
                    </button>
                    <button type="button" ng-if="${options.length} <= 1 && !${scope.dropdownAlwaysShown}">
                        <span ng-if="selected">{{ selected.value }}</span>
                        <span ng-if="!selected">Wybierz opcję</span>
                    </button>
                    <ul id="select-to-dropdown-${scope.uniqueId}">
                        <li ng-repeat-start="option in options" ng-if="0"></li>
                        <li ng-if="option != selected && option.canBuy" ng-click="select(option)">
                            <span>{{ option.value }}</span>
                            <span ng-class="{'no-description': !option.description}">
                                <span ng-bind-html="option.description"></span>
                            </span>
                            <span>
                                <span ng-bind-html="option.info"></span>
                            </span>
                        </li>
                        <li ng-if="option == selected" class="selected" ng-click="close()">
                            <span>{{ option.value }}</span>
                            <span ng-class="{'no-description': !option.description}">
                                <span ng-bind-html="option.description"></span>
                            </span>
                            <span>
                                <span ng-bind-html="option.info"></span>
                            </span>
                        </li>
                        <li ng-if="option != selected && !option.canBuy" ng-click="selectNotAvailableVariant(option)">
                            <span>
                                <span tooltips
                                tooltip-template="Wariant niedostępny."
                                tooltip-side="bottom">{{ option.value }}</span>
                            </span>
                            <span ng-class="{'no-description': !option.description}">
                                <span 
                                    tooltips
                                    tooltip-template="Wariant niedostępny."
                                    tooltip-side="bottom">
                                    <span ng-bind-html="option.description"></span>
                                </span>
                            </span>
                            <span>
                                <span
                                    tooltips
                                    tooltip-template="Wariant niedostępny."
                                    tooltip-side="bottom">
                                    <span ng-bind-html="option.info"></span>
                                </span>
                            </span>
                        </li>
                        <li ng-repeat-end ng-if="0"></li>
                    </ul>
                </div>`);
            element.parent().append(container);

            this.$compile(container.children())(scope);

            scope.$on('$destroy', () => {
                element.css({display: 'inline-block'});
                container.remove();
            });

            if (options.length === 1) {
                scope.select(options[0]);
            }

            this.initComplete = true;
        }
    }

    static directiveFactory($compile, $timeout) {
        'ngInject';
        return new SelectToDropdownDirective($compile, $timeout);
    }
}

export default SelectToDropdownDirective;
